/**
 * Created by Bart Decorte
 * Date: 2019-09-10
 * Time: 22:29
 */
import Page from '../pages/Page';

export default class QuestionsIndex extends Page {}



// WEBPACK FOOTER //
// ./resources/assets/js/content/QuestionsIndex.js